import React from 'react';
import {CardTitle, Flex, FlexItem} from "@chatui/core";
import './cardWithTitle.css'
function CardTitleWithStatus(props) {
    return (
        <Flex center>
            <FlexItem>
                <CardTitle className={'card-title-text'}>{props.title}</CardTitle>
            </FlexItem>
            <div className={"title-status-tag"}>{props.statusText}</div>
        </Flex>
    );
}

export default CardTitleWithStatus;